import has from '@dojo/framework/core/has';
import { getCategoryControl, CategoryConfiguration, LogLevel, LoggerType, CategoryLogFormat, Category, CategoryServiceFactory } from 'typescript-logging';
import { after } from 'aspect-ts';
import { LccTrakLogger, send_messages } from './logger';
export { send_messages } from './logger';
const config = new CategoryConfiguration(has('dev-build') ? LogLevel.Debug : LogLevel.Info, LoggerType.Custom, new CategoryLogFormat(), (category, runtimeSettings) => new LccTrakLogger(category, runtimeSettings));
CategoryServiceFactory.setDefaultConfiguration(config);
window.hcstatic.logging = getCategoryControl;
export const logTrak = new Category('logging');
export const logConsole = new Category('console', logTrak);
export const logLp = new Category('lp', logTrak);
export const logQuiz = new Category('quiz', logTrak);
export const logRoute = new Category('route', logTrak);
export const logRpc = new Category('rpc', logTrak);
export const logSystem = new Category('system', logTrak);
export const logTimesync = new Category('timesync', logTrak);
export const logUser = new Category('user', logTrak);
export const logLac = new Category('lac', logTrak);
document.body.addEventListener('beforeunload', () => {
    logSystem.info(() => 'log out due to window close');
    send_messages();
});
if (window.onerror === null) {
    window.onerror = function onerror(message, source, lineno, columnNumber, error) {
        error && logSystem.error(`${message} ${source}: ${lineno}`, error);
    };
}
else {
    after(window, 'onerror', (message, source, lineno, columnNumber, error) => {
        error && logSystem.error(`${message} ${source}: ${lineno}`, error);
    });
}
function consoleOverride(func, ...args) {
    let error = func === 'error' ? new Error('unknown') : null;
    const msgmap = args.map((value) => {
        if (typeof value === 'string') {
            return value;
        }
        if (typeof value === 'number') {
            return `${value}`;
        }
        if (value instanceof Error) {
            error = value;
            return undefined;
        }
        return JSON.stringify(value);
    });
    const msg = msgmap.filter((v) => v !== undefined).join(' ');
    if (error !== null) {
        logConsole.error(msg, error);
    }
    else if (func === 'warn') {
        logConsole.warn(() => msg);
    }
    else if (func === 'debug') {
        logConsole.debug(() => msg);
    }
    else if (func === 'rlog') {
        logSystem.info(() => msg);
    }
    else {
        logConsole.info(() => msg);
    }
}
for (const func of ['error', 'warn', 'info', 'debug', 'rlog']) {
    if (func in console) {
        after(console, func, consoleOverride.bind(console, func));
    }
    else {
        console[func] = consoleOverride.bind(console, func);
    }
}
